import { Grid, Typography } from "@mui/material";
import React from "react";
import { KandidatByIDResponse } from "../../../models/Kandidat";
import {
  BaseGrid,
  SubTitleTypography,
  TitleTypography,
} from "../KandidatViewPage";
import separateNumber from "../../../utils/formatPrice";

type Props = { data: KandidatByIDResponse };

export default function DataKandidatPage({ data }: Props) {
  return (
    <BaseGrid container>
      <Grid
        container
        item
        xs={12}
        sx={{
          backgroundColor: "#00ACED",
          color: "#fff",
        }}
      >
        <TitleTypography>Data Kandidat</TitleTypography>
      </Grid>
      <Grid container item xs={6} direction="column">
        <SubTitleTypography>Divisi</SubTitleTypography>
        <Typography>{data.DIVISI}</Typography>
        <SubTitleTypography>Pekerjaan</SubTitleTypography>
        <Typography>{data.JOB}</Typography>
        <SubTitleTypography>Lokasi</SubTitleTypography>
        <Typography>{data.LOKASI}</Typography>
        <SubTitleTypography>Status Karyawan</SubTitleTypography>
        <Typography>{data.STATUS_KARYAWAN}</Typography>
        <SubTitleTypography>Tanggal Apply</SubTitleTypography>
        <Typography>{data.TANGGAL_APPLY}</Typography>
      </Grid>
      <Grid container item xs={6} direction="column">
        <SubTitleTypography>Gaji yang Diinginkan</SubTitleTypography>
        <Typography>Rp. {separateNumber(data.REQUEST_GAJI)}</Typography>
        <SubTitleTypography>Ketersediaan Waktu Bergabung</SubTitleTypography>
        <Typography>{data.AVAILABILITY}</Typography>
        <SubTitleTypography>
          Uraian Tugas dan Tanggung Jawab Pekerjaan Terakhir
        </SubTitleTypography>
          <Typography>
              {data.URAIAN.split('\n').map((line, index) => (
                  <React.Fragment key={index}>
                      {line}
                      {index < data.URAIAN.split('\n').length - 1 && <br />}
                  </React.Fragment>
              ))}
          </Typography>
      </Grid>
    </BaseGrid>
  );
}
